'use es6';

import { Record } from 'immutable';
import * as Actions from 'FormsUI/actions/DialogsAndPanels';
import { StateKeys } from 'FormsUI/constants/DialogsAndPanels';
const INIT_STATE = new Record({
  [StateKeys.DIALOG_KEY]: null,
  [StateKeys.PANEL_KEY]: null,
  [StateKeys.DIALOG_FORM_GUID]: '',
  [StateKeys.DATA]: {}
})();
export const dialogsAndPanels = (state = INIT_STATE, action) => {
  switch (action.type) {
    case Actions.SHOW_DIALOG:
      return state.set(StateKeys.DIALOG_KEY, action.dialogKey).set(StateKeys.DIALOG_FORM_GUID, action.formGuid).set(StateKeys.DATA, action.data);
    case Actions.CLOSE_DIALOG:
      return state.set(StateKeys.DIALOG_KEY, INIT_STATE.get(StateKeys.DIALOG_KEY)).set(StateKeys.DIALOG_FORM_GUID, INIT_STATE.get(StateKeys.DIALOG_FORM_GUID));
    case Actions.SHOW_PANEL:
      return state.set(StateKeys.PANEL_KEY, action.panelKey);
    case Actions.CLOSE_PANEL:
      return state.set(StateKeys.PANEL_KEY, INIT_STATE.get(StateKeys.PANEL_KEY));
    default:
      return state;
  }
};